import { store, setCurrentTime } from '../core/store';
import type { StreamForgeHLS, QualityLevel } from '../core/HLSManager';

// ─── SVG Icons ──────────────────────────────────────────────
const ICONS = {
  play: `<svg width="24" height="24" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21"/></svg>`,
  pause: `<svg width="24" height="24" viewBox="0 0 24 24" fill="white"><rect x="5" y="3" width="4" height="18"/><rect x="15" y="3" width="4" height="18"/></svg>`,
  volumeHigh: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"><polygon points="11,5 6,9 2,9 2,15 6,15 11,19" fill="white"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>`,
  volumeMute: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"><polygon points="11,5 6,9 2,9 2,15 6,15 11,19" fill="white"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>`,
  fullscreen: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"><polyline points="15,3 21,3 21,9"/><polyline points="9,21 3,21 3,15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>`,
  exitFullscreen: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"><polyline points="4,14 10,14 10,20"/><polyline points="20,10 14,10 14,4"/><line x1="14" y1="10" x2="21" y2="3"/><line x1="3" y1="21" x2="10" y2="14"/></svg>`,
  settings: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>`,
  // Large center overlay icons
  playLarge: `<svg width="64" height="64" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21"/></svg>`,
  pauseLarge: `<svg width="64" height="64" viewBox="0 0 24 24" fill="white"><rect x="5" y="3" width="4" height="18"/><rect x="15" y="3" width="4" height="18"/></svg>`,
  chevronRight: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>`,
  chevronLeft: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>`,
  quality: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>`,
  speed: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>`,
  audio: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path></svg>`,
  visual: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>`,
  sleep: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>`,
};

function formatTime(seconds: number): string {
  if (isNaN(seconds) || !isFinite(seconds)) return '0:00';
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export class UIController {
  private container: HTMLElement;
  private video: HTMLVideoElement;
  private hlsManager: StreamForgeHLS;
  private controlsVisible: boolean = true;
  private hideTimeout: number | null = null;

  // DOM refs
  private controlsEl: HTMLElement | null = null;
  private playBtn: HTMLElement | null = null;
  private seekBar: HTMLInputElement | null = null;
  private seekTrack: HTMLElement | null = null;
  private timeDisplay: HTMLElement | null = null;
  private volumeBtn: HTMLElement | null = null;
  private volumeSlider: HTMLInputElement | null = null;
  private fullscreenBtn: HTMLElement | null = null;
  private settingsBtn: HTMLElement | null = null;
  private settingsMenu: HTMLElement | null = null;
  private overlayIcon: HTMLElement | null = null;
  private isSeeking: boolean = false;
  private qualityLevels: QualityLevel[] = [];
  private overlayTimeout: number | null = null;
  // Feature states
  private volumeNormalized: boolean = false;
  private volumeBoosted: boolean = false;
  private cinematicLighting: boolean = true;
  private annotationsEnabled: boolean = false;
  private subtitlesEnabled: boolean = false;
  private currentSpeed: number = 1;
  private sleepTimerId: number | null = null;
  private sleepMinutes: number = 0;
  private gainNode: GainNode | null = null;
  private audioCtx: AudioContext | null = null;

  public get isControlsVisible() { return this.controlsVisible; }

  constructor(container: HTMLElement, video: HTMLVideoElement, hlsManager: StreamForgeHLS) {
    this.container = container;
    this.video = video;
    this.hlsManager = hlsManager;

    this.injectStyles();
    this.buildOverlay();
    this.buildControls();
    this.setupInteractions();
    this.setupVideoSync();
    this.setupStoreSubscription();
    this.setupQualityLevels();
  }

  // ─── Center Overlay (Play/Pause animation) ────────────────
  private buildOverlay() {
    const overlay = document.createElement('div');
    overlay.className = 'sf-state-overlay';
    Object.assign(overlay.style, {
      position: 'absolute',
      top: '0', left: '0', right: '0', bottom: '0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'none',
      zIndex: '200',
    });

    const iconWrap = document.createElement('div');
    iconWrap.className = 'sf-state-icon';
    Object.assign(iconWrap.style, {
      width: '90px', height: '90px',
      borderRadius: '50%',
      background: 'rgba(0,0,0,0.45)',
      backdropFilter: 'blur(8px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      opacity: '0',
      transform: 'scale(0.6)',
      transition: 'opacity 0.3s ease, transform 0.3s ease',
    });
    this.overlayIcon = iconWrap;

    overlay.appendChild(iconWrap);
    this.container.appendChild(overlay);
  }

  private flashOverlay(isPaused: boolean) {
    if (!this.overlayIcon) return;
    if (this.overlayTimeout) clearTimeout(this.overlayTimeout);

    this.overlayIcon.innerHTML = isPaused ? ICONS.pauseLarge : ICONS.playLarge;
    this.overlayIcon.style.opacity = '1';
    this.overlayIcon.style.transform = 'scale(1)';

    this.overlayTimeout = window.setTimeout(() => {
      if (this.overlayIcon) {
        this.overlayIcon.style.opacity = '0';
        this.overlayIcon.style.transform = 'scale(1.3)';
      }
    }, 800);
  }

  // ─── Build Controls DOM ───────────────────────────────────
  private buildControls() {
    this.container.style.position = 'relative';
    this.container.style.overflow = 'hidden';
    this.container.style.borderRadius = '12px';
    this.container.style.background = '#000';

    const controls = document.createElement('div');
    controls.className = 'sf-controls';
    Object.assign(controls.style, {
      position: 'absolute',
      bottom: '0', left: '0', right: '0',
      padding: '0 12px 14px',
      background: 'linear-gradient(transparent 0%, rgba(0,0,0,0.3) 40%, rgba(0,0,0,0.75) 100%)',
      zIndex: '100',
      transition: 'opacity 0.3s ease, transform 0.3s ease',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
    });
    this.controlsEl = controls;

    // ── Seek bar row ──
    const seekRow = document.createElement('div');
    Object.assign(seekRow.style, {
      position: 'relative',
      width: '100%', height: '20px',
      display: 'flex', alignItems: 'center',
      cursor: 'pointer',
    });

    const seekTrack = document.createElement('div');
    Object.assign(seekTrack.style, {
      position: 'absolute', left: '0', right: '0',
      height: '4px',
      background: 'rgba(255,255,255,0.2)',
      borderRadius: '2px',
      pointerEvents: 'none',
      transition: 'height 0.15s ease',
    });

    const seekFill = document.createElement('div');
    seekFill.className = 'sf-seek-fill';
    Object.assign(seekFill.style, {
      position: 'absolute', left: '0', top: '0', bottom: '0',
      width: '0%',
      background: '#6366f1',
      borderRadius: '2px',
      pointerEvents: 'none',
    });
    seekTrack.appendChild(seekFill);
    this.seekTrack = seekTrack;

    const seekInput = document.createElement('input');
    seekInput.type = 'range'; seekInput.min = '0'; seekInput.max = '1000'; seekInput.value = '0';
    seekInput.className = 'sf-seek-input';
    Object.assign(seekInput.style, {
      position: 'absolute', left: '0', right: '0',
      width: '100%', height: '20px',
      opacity: '0', cursor: 'pointer',
      margin: '0', zIndex: '2',
    });
    this.seekBar = seekInput;

    seekRow.appendChild(seekTrack);
    seekRow.appendChild(seekInput);
    seekRow.addEventListener('mouseenter', () => { seekTrack.style.height = '6px'; });
    seekRow.addEventListener('mouseleave', () => { seekTrack.style.height = '4px'; });

    // ── Button row — each element in its own frosted pill ──
    const btnRow = document.createElement('div');
    Object.assign(btnRow.style, {
      display: 'flex', alignItems: 'center', gap: '6px',
    });

    // Helper: wrap any element in a frosted glass pill
    const pill = (child: HTMLElement, extra?: Partial<CSSStyleDeclaration>) => {
      const wrap = document.createElement('div');
      Object.assign(wrap.style, {
        display: 'flex', alignItems: 'center',
        background: 'rgba(255,255,255,0.07)',
        backdropFilter: 'blur(12px)',
        borderRadius: '12px',
        padding: '3px',
        border: '1px solid rgba(255,255,255,0.06)',
        transition: 'background 0.2s ease',
        ...extra,
      });
      wrap.appendChild(child);
      return wrap;
    };

    this.playBtn = this.createButton(ICONS.play, () => this.togglePlay());
    const playPill = pill(this.playBtn);

    // Time display pill
    this.timeDisplay = document.createElement('span');
    Object.assign(this.timeDisplay.style, {
      color: 'rgba(255,255,255,0.7)',
      fontSize: '12px',
      fontFamily: "'Inter', system-ui, sans-serif",
      letterSpacing: '0.3px',
      userSelect: 'none',
      whiteSpace: 'nowrap',
    });
    this.timeDisplay.textContent = '0:00 / 0:00';
    const timePill = pill(this.timeDisplay, { padding: '6px 12px' });

    const spacer = document.createElement('div');
    spacer.style.flex = '1';

    // Volume pill (button + slider together)
    this.volumeBtn = this.createButton(ICONS.volumeHigh, () => this.toggleMute());
    const volSlider = document.createElement('input');
    volSlider.type = 'range'; volSlider.min = '0'; volSlider.max = '100'; volSlider.value = '100';
    volSlider.className = 'sf-vol-slider';
    Object.assign(volSlider.style, { width: '60px', height: '3px', cursor: 'pointer', accentColor: '#6366f1' });
    this.volumeSlider = volSlider;
    const volWrap = document.createElement('div');
    Object.assign(volWrap.style, {
      display: 'flex', alignItems: 'center', gap: '4px',
    });
    volWrap.append(this.volumeBtn, this.volumeSlider);
    const volPill = pill(volWrap, { padding: '3px 8px 3px 3px' });

    // Settings pill
    this.settingsBtn = this.createButton(ICONS.settings, () => this.toggleSettings());
    this.buildSettingsMenu();
    const settingsPill = pill(this.settingsBtn);

    // Fullscreen pill
    this.fullscreenBtn = this.createButton(ICONS.fullscreen, () => this.toggleFullscreen());
    const fsPill = pill(this.fullscreenBtn);

    // Assemble
    btnRow.append(playPill, timePill, spacer, volPill, settingsPill, fsPill);
    controls.append(seekRow, btnRow);
    this.container.append(controls, this.settingsMenu!);
  }

  private buildSettingsMenu() {
    const menu = document.createElement('div');
    menu.className = 'sf-settings-menu';
    Object.assign(menu.style, {
      position: 'absolute',
      bottom: '70px', right: '16px',
      width: '280px',
      maxHeight: '400px',
      overflowY: 'auto',
      background: 'rgba(10, 15, 30, 0.96)',
      backdropFilter: 'blur(20px)',
      border: '1px solid rgba(255,255,255,0.08)',
      borderRadius: '14px',
      padding: '6px 0',
      zIndex: '300',
      opacity: '0',
      transform: 'translateY(8px) scale(0.95)',
      transition: 'opacity 0.2s ease, transform 0.2s ease, width 0.3s ease, height 0.3s ease',
      pointerEvents: 'none',
      fontFamily: "'Inter', system-ui, sans-serif",
    });

    // Custom scrollbar
    const scrollStyle = document.createElement('style');
    scrollStyle.textContent = `
      .sf-settings-menu::-webkit-scrollbar { width: 4px; }
      .sf-settings-menu::-webkit-scrollbar-track { background: transparent; }
      .sf-settings-menu::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 2px; }
    `;
    document.head.appendChild(scrollStyle);

    this.settingsMenu = menu;
    this.renderSettingsPage('main');
  }

  private getQualityLabel(): string {
      const activeIdx = this.hlsManager.getCurrentLevel();
      if (activeIdx === -1) return 'Otomatik';
      const level = this.qualityLevels.find(l => l.index === activeIdx);
      return level ? level.label : 'Otomatik';
  }

  private createPageLink(label: string, targetPage: 'quality' | 'speed' | 'sleep' | 'audio' | 'visual', iconStr: string, activeValue?: string): HTMLElement {
      const row = document.createElement('div');
      Object.assign(row.style, {
          padding: '12px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          cursor: 'pointer', transition: 'background 0.15s ease', color: 'rgba(255,255,255,0.85)'
      });
      row.addEventListener('mouseenter', () => { row.style.background = 'rgba(255,255,255,0.06)'; });
      row.addEventListener('mouseleave', () => { row.style.background = 'transparent'; });
      row.addEventListener('click', (e) => { e.stopPropagation(); this.renderSettingsPage(targetPage); });

      const left = document.createElement('div');
      Object.assign(left.style, { display: 'flex', alignItems: 'center', gap: '12px' });
      
      const iconWrap = document.createElement('div');
      iconWrap.innerHTML = iconStr;
      Object.assign(iconWrap.style, { display: 'flex', opacity: '0.9' });

      const title = document.createElement('span');
      Object.assign(title.style, { fontSize: '14px', fontWeight: '500' });
      title.textContent = label;
      left.append(iconWrap, title);

      const right = document.createElement('div');
      Object.assign(right.style, { display: 'flex', alignItems: 'center', gap: '6px' });
      
      if (activeValue) {
          const val = document.createElement('span');
          Object.assign(val.style, { fontSize: '13px', color: 'rgba(255,255,255,0.5)' });
          val.textContent = activeValue;
          right.appendChild(val);
      }

      const chevWrap = document.createElement('div');
      chevWrap.innerHTML = ICONS.chevronRight;
      Object.assign(chevWrap.style, { display: 'flex', opacity: '0.4' });
      right.appendChild(chevWrap);

      row.append(left, right);
      return row;
  }

  private renderSettingsPage(page: 'main' | 'quality' | 'speed' | 'sleep' | 'audio' | 'visual') {
      if (!this.settingsMenu) return;
      this.settingsMenu.innerHTML = '';
      this.settingsMenu.style.width = page === 'main' ? '280px' : '260px';

      if (page === 'main') {
          this.settingsMenu.appendChild(this.createPageLink('Kalite', 'quality', ICONS.quality, this.getQualityLabel()));
          this.settingsMenu.appendChild(this.createPageLink('Çalma Hızı', 'speed', ICONS.speed, this.currentSpeed === 1 ? 'Normal' : `${this.currentSpeed}x`));
          this.settingsMenu.appendChild(this.createMenuDivider());
          this.settingsMenu.appendChild(this.createPageLink('Ses Ayarları', 'audio', ICONS.audio));
          this.settingsMenu.appendChild(this.createPageLink('Görünüm', 'visual', ICONS.visual));
          this.settingsMenu.appendChild(this.createMenuDivider());
          this.settingsMenu.appendChild(this.createPageLink('Zamanlayıcı', 'sleep', ICONS.sleep, this.sleepMinutes === 0 ? 'Kapalı' : `${this.sleepMinutes} dk`));
      } else {
          // Add back button header
          const header = document.createElement('div');
          Object.assign(header.style, {
              padding: '12px 16px 8px', display: 'flex', alignItems: 'center', gap: '10px',
              cursor: 'pointer', borderBottom: '1px solid rgba(255,255,255,0.08)',
              color: 'rgba(255,255,255,0.9)', fontSize: '14px', fontWeight: '500',
              marginBottom: '4px'
          });
          
          const titleMap: Record<string, string> = {
             quality: 'Kalite', speed: 'Çalma Hızı', audio: 'Ses Ayarları',
             visual: 'Görünüm', sleep: 'Uyku Zamanlayıcı'
          };
          header.innerHTML = `<div style="display:flex;opacity:0.7">${ICONS.chevronLeft}</div> <span>${titleMap[page]}</span>`;
          header.addEventListener('mouseenter', () => { header.style.background = 'rgba(255,255,255,0.04)'; });
          header.addEventListener('mouseleave', () => { header.style.background = 'transparent'; });
          header.addEventListener('click', (e) => { e.stopPropagation(); this.renderSettingsPage('main'); });
          this.settingsMenu.appendChild(header);

          if (page === 'quality') {
              this.settingsMenu.appendChild(this.createMenuSection('Çözünürlük', 'sf-quality-list'));
              this.populateQualityMenu(); // Requires list to be present in DOM
          } else if (page === 'speed') {
              this.settingsMenu.appendChild(this.createSpeedSection());
          } else if (page === 'audio') {
              this.settingsMenu.appendChild(this.createToggleRow('Sabit Ses', 'Ses seviyesini dengeler', this.volumeNormalized, () => this.toggleVolumeNormalization()));
              this.settingsMenu.appendChild(this.createToggleRow('Ses Artırma', 'Sesi %200\'e yükselt', this.volumeBoosted, () => this.toggleVolumeBoost()));
          } else if (page === 'visual') {
              this.settingsMenu.appendChild(this.createToggleRow('Sinematik Işık', 'Ambient arka plan efekti', this.cinematicLighting, () => this.toggleCinematicLighting()));
              this.settingsMenu.appendChild(this.createToggleRow('Ek Açıklamalar', 'Video üzeri notları göster', this.annotationsEnabled, () => this.toggleAnnotations()));
              this.settingsMenu.appendChild(this.createToggleRow('Alt Yazılar', 'Mevcut altyazıları aç', this.subtitlesEnabled, () => this.toggleSubtitles()));
          } else if (page === 'sleep') {
              this.settingsMenu.appendChild(this.createSleepTimerSection());
          }
      }
  }

  private createMenuSection(title: string, listClass: string): HTMLElement {
    const section = document.createElement('div');
    const header = document.createElement('div');
    Object.assign(header.style, {
      padding: '10px 16px 6px',
      fontSize: '10px', fontWeight: '600',
      textTransform: 'uppercase', letterSpacing: '1.2px',
      color: 'rgba(255,255,255,0.3)',
    });
    header.textContent = title;
    section.appendChild(header);

    const list = document.createElement('div');
    list.className = listClass;
    section.appendChild(list);
    return section;
  }

  private createMenuDivider(): HTMLElement {
    const div = document.createElement('div');
    Object.assign(div.style, {
      height: '1px', margin: '4px 12px',
      background: 'rgba(255,255,255,0.06)',
    });
    return div;
  }

  private createToggleRow(label: string, desc: string, active: boolean, onClick: () => void): HTMLElement {
    const row = document.createElement('div');
    Object.assign(row.style, {
      padding: '10px 16px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      cursor: 'pointer', transition: 'background 0.15s ease',
    });
    row.addEventListener('mouseenter', () => { row.style.background = 'rgba(255,255,255,0.04)'; });
    row.addEventListener('mouseleave', () => { row.style.background = 'transparent'; });

    const left = document.createElement('div');
    const title = document.createElement('div');
    Object.assign(title.style, { fontSize: '13px', color: 'rgba(255,255,255,0.85)' });
    title.textContent = label;
    const sub = document.createElement('div');
    Object.assign(sub.style, { fontSize: '10px', color: 'rgba(255,255,255,0.3)', marginTop: '2px' });
    sub.textContent = desc;
    left.append(title, sub);

    // Toggle switch
    const toggle = document.createElement('div');
    toggle.className = 'sf-toggle';
    Object.assign(toggle.style, {
      width: '36px', height: '20px',
      borderRadius: '10px',
      background: active ? '#6366f1' : 'rgba(255,255,255,0.15)',
      position: 'relative',
      transition: 'background 0.2s ease',
      flexShrink: '0',
    });
    const knob = document.createElement('div');
    Object.assign(knob.style, {
      width: '16px', height: '16px',
      borderRadius: '50%',
      background: 'white',
      position: 'absolute',
      top: '2px',
      left: active ? '18px' : '2px',
      transition: 'left 0.2s ease',
      boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
    });
    toggle.appendChild(knob);

    row.append(left, toggle);
    row.addEventListener('click', (e) => {
      e.stopPropagation();
      onClick();
      // Toggle visual
      const isNowActive = toggle.style.background === 'rgb(99, 102, 241)';
      const newState = !isNowActive;
      toggle.style.background = newState ? '#6366f1' : 'rgba(255,255,255,0.15)';
      knob.style.left = newState ? '18px' : '2px';
    });

    return row;
  }

  private createSpeedSection(): HTMLElement {
    const section = document.createElement('div');
    const header = document.createElement('div');
    Object.assign(header.style, {
      padding: '10px 16px 6px',
      fontSize: '10px', fontWeight: '600',
      textTransform: 'uppercase', letterSpacing: '1.2px',
      color: 'rgba(255,255,255,0.3)',
    });
    header.textContent = 'Çalma Hızı';
    section.appendChild(header);

    const speeds = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
    const row = document.createElement('div');
    Object.assign(row.style, {
      display: 'flex', gap: '4px', padding: '4px 12px 8px',
      flexWrap: 'wrap',
    });

    speeds.forEach(speed => {
      const chip = document.createElement('button');
      chip.textContent = speed === 1 ? 'Normal' : `${speed}x`;
      chip.className = 'sf-speed-chip';
      Object.assign(chip.style, {
        padding: '4px 10px',
        fontSize: '11px',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        background: speed === this.currentSpeed ? '#6366f1' : 'rgba(255,255,255,0.08)',
        color: speed === this.currentSpeed ? 'white' : 'rgba(255,255,255,0.6)',
        transition: 'all 0.15s ease',
        outline: 'none',
        fontFamily: "'Inter', system-ui, sans-serif",
      });
      chip.addEventListener('click', (e) => {
        e.stopPropagation();
        this.setPlaybackSpeed(speed);
        row.querySelectorAll('.sf-speed-chip').forEach(c => {
          const el = c as HTMLElement;
          const s = el.textContent === 'Normal' ? 1 : parseFloat(el.textContent!);
          el.style.background = s === speed ? '#6366f1' : 'rgba(255,255,255,0.08)';
          el.style.color = s === speed ? 'white' : 'rgba(255,255,255,0.6)';
        });
      });
      row.appendChild(chip);
    });

    section.appendChild(row);
    return section;
  }

  private createSleepTimerSection(): HTMLElement {
    const section = document.createElement('div');
    const header = document.createElement('div');
    Object.assign(header.style, {
      padding: '10px 16px 6px',
      fontSize: '10px', fontWeight: '600',
      textTransform: 'uppercase', letterSpacing: '1.2px',
      color: 'rgba(255,255,255,0.3)',
    });
    header.textContent = 'Uyku Zamanlayıcı';
    section.appendChild(header);

    const options = [0, 15, 30, 45, 60, 90];
    const row = document.createElement('div');
    Object.assign(row.style, {
      display: 'flex', gap: '4px', padding: '4px 12px 8px',
      flexWrap: 'wrap',
    });

    options.forEach(min => {
      const chip = document.createElement('button');
      chip.textContent = min === 0 ? 'Kapalı' : `${min} dk`;
      chip.className = 'sf-sleep-chip';
      Object.assign(chip.style, {
        padding: '4px 10px',
        fontSize: '11px',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        background: min === this.sleepMinutes ? '#6366f1' : 'rgba(255,255,255,0.08)',
        color: min === this.sleepMinutes ? 'white' : 'rgba(255,255,255,0.6)',
        transition: 'all 0.15s ease',
        outline: 'none',
        fontFamily: "'Inter', system-ui, sans-serif",
      });
      chip.addEventListener('click', (e) => {
        e.stopPropagation();
        this.setSleepTimer(min);
        row.querySelectorAll('.sf-sleep-chip').forEach(c => {
          const el = c as HTMLElement;
          const m = el.textContent === 'Kapalı' ? 0 : parseInt(el.textContent!);
          el.style.background = m === min ? '#6366f1' : 'rgba(255,255,255,0.08)';
          el.style.color = m === min ? 'white' : 'rgba(255,255,255,0.6)';
        });
      });
      row.appendChild(chip);
    });

    section.appendChild(row);
    return section;
  }

  private populateQualityMenu() {
    const list = this.settingsMenu?.querySelector('.sf-quality-list');
    if (!list) return;
    list.innerHTML = '';

    const activeIdx = this.hlsManager.getCurrentLevel();

    const autoItem = this.createSelectionItem('Otomatik', -1, activeIdx === -1);
    list.appendChild(autoItem);

    const sorted = [...this.qualityLevels].sort((a, b) => b.height - a.height);
    sorted.forEach(level => {
      list.appendChild(this.createSelectionItem(level.label, level.index, level.index === activeIdx));
    });
  }

  private createSelectionItem(label: string, index: number, active: boolean): HTMLElement {
    const item = document.createElement('div');
    Object.assign(item.style, {
      padding: '7px 16px', fontSize: '13px',
      color: active ? '#6366f1' : 'rgba(255,255,255,0.7)',
      cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px',
      transition: 'background 0.15s ease',
    });

    const dot = document.createElement('div');
    Object.assign(dot.style, {
      width: '5px', height: '5px', borderRadius: '50%',
      background: active ? '#6366f1' : 'transparent',
      transition: 'background 0.15s ease',
    });

    const text = document.createElement('span');
    text.textContent = label;
    item.append(dot, text);

    item.addEventListener('mouseenter', () => { item.style.background = 'rgba(255,255,255,0.04)'; });
    item.addEventListener('mouseleave', () => { item.style.background = 'transparent'; });
    item.addEventListener('click', (e) => {
      e.stopPropagation();
      this.hlsManager.setQuality(index);
      this.highlightActiveQuality(index);
    });

    item.dataset.qualityIndex = String(index);
    return item;
  }

  private highlightActiveQuality(activeIndex: number) {
    const items = this.settingsMenu?.querySelectorAll('.sf-quality-list > div');
    items?.forEach(item => {
      const el = item as HTMLElement;
      const idx = Number(el.dataset.qualityIndex);
      const isActive = idx === activeIndex;
      el.style.color = isActive ? '#6366f1' : 'rgba(255,255,255,0.7)';
      const dot = el.querySelector('div') as HTMLElement;
      if (dot) dot.style.background = isActive ? '#6366f1' : 'transparent';
    });
  }

  // ─── Feature Actions ──────────────────────────────────────
  private setPlaybackSpeed(speed: number) {
    this.currentSpeed = speed;
    this.video.playbackRate = speed;
    console.log(`[StreamForge] Playback speed: ${speed}x`);
  }

  private toggleVolumeNormalization() {
    this.volumeNormalized = !this.volumeNormalized;
    // Volume normalization is a conceptual flag; real implementation 
    // would use AudioContext compressor. For now, we clamp volume.
    console.log(`[StreamForge] Volume normalization: ${this.volumeNormalized ? 'ON' : 'OFF'}`);
  }

  private toggleVolumeBoost() {
    this.volumeBoosted = !this.volumeBoosted;
    this.ensureAudioContext();
    if (this.gainNode) {
      this.gainNode.gain.value = this.volumeBoosted ? 2.0 : 1.0;
    }
    console.log(`[StreamForge] Volume boost: ${this.volumeBoosted ? 'ON (200%)' : 'OFF'}`);
  }

  private ensureAudioContext() {
    if (this.audioCtx) return;
    this.audioCtx = new AudioContext();
    const source = this.audioCtx.createMediaElementSource(this.video);
    this.gainNode = this.audioCtx.createGain();
    source.connect(this.gainNode);
    this.gainNode.connect(this.audioCtx.destination);
  }

  private toggleCinematicLighting() {
    this.cinematicLighting = !this.cinematicLighting;
    // Toggle the ambient glow CSS variable
    if (!this.cinematicLighting) {
      document.documentElement.style.setProperty('--sf-vibrant-glow', 'transparent');
    }
    console.log(`[StreamForge] Cinematic lighting: ${this.cinematicLighting ? 'ON' : 'OFF'}`);
  }

  private toggleAnnotations() {
    this.annotationsEnabled = !this.annotationsEnabled;
    console.log(`[StreamForge] Annotations: ${this.annotationsEnabled ? 'ON' : 'OFF'}`);
  }

  private toggleSubtitles() {
    this.subtitlesEnabled = !this.subtitlesEnabled;
    // Toggle text tracks if available
    const tracks = this.video.textTracks;
    for (let i = 0; i < tracks.length; i++) {
      tracks[i].mode = this.subtitlesEnabled ? 'showing' : 'hidden';
    }
    console.log(`[StreamForge] Subtitles: ${this.subtitlesEnabled ? 'ON' : 'OFF'}`);
  }

  private setSleepTimer(minutes: number) {
    if (this.sleepTimerId) {
      clearTimeout(this.sleepTimerId);
      this.sleepTimerId = null;
    }
    this.sleepMinutes = minutes;
    if (minutes > 0) {
      this.sleepTimerId = window.setTimeout(() => {
        this.video.pause();
        console.log(`[StreamForge] Sleep timer triggered after ${minutes} minutes`);
      }, minutes * 60 * 1000);
      console.log(`[StreamForge] Sleep timer set: ${minutes} minutes`);
    } else {
      console.log('[StreamForge] Sleep timer cancelled');
    }
  }

  private createButton(svg: string, onClick: () => void): HTMLElement {
    const btn = document.createElement('button');
    btn.innerHTML = svg;
    Object.assign(btn.style, {
      background: 'rgba(255,255,255,0.06)',
      border: 'none',
      cursor: 'pointer',
      padding: '7px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '10px',
      transition: 'background 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease',
      outline: 'none',
    });
    btn.addEventListener('mouseenter', () => {
      btn.style.background = 'rgba(255,255,255,0.14)';
      btn.style.boxShadow = '0 0 12px rgba(99,102,241,0.15)';
    });
    btn.addEventListener('mouseleave', () => {
      btn.style.background = 'rgba(255,255,255,0.06)';
      btn.style.boxShadow = 'none';
    });
    btn.addEventListener('mousedown', () => { btn.style.transform = 'scale(0.92)'; });
    btn.addEventListener('mouseup', () => { btn.style.transform = 'scale(1)'; });
    btn.addEventListener('click', (e) => { e.stopPropagation(); onClick(); });
    return btn;
  }

  private injectStyles() {
    if (document.getElementById('sf-player-styles')) return;
    const style = document.createElement('style');
    style.id = 'sf-player-styles';
    style.textContent = `
      .sf-seek-input::-webkit-slider-thumb { -webkit-appearance: none; width: 14px; height: 14px; background: #6366f1; border-radius: 50%; cursor: pointer; }
      .sf-seek-input::-moz-range-thumb { width: 14px; height: 14px; background: #6366f1; border-radius: 50%; border: none; cursor: pointer; }
      .sf-vol-slider::-webkit-slider-thumb { -webkit-appearance: none; width: 12px; height: 12px; background: white; border-radius: 50%; cursor: pointer; }
      .sf-vol-slider::-moz-range-thumb { width: 12px; height: 12px; background: white; border-radius: 50%; border: none; cursor: pointer; }
      .sf-video-element { width: 100%; height: 100%; display: block; object-fit: contain; }
      #player-host { position: relative; aspect-ratio: 16/9; }
    `;
    document.head.appendChild(style);
  }

  // ─── Interactions ─────────────────────────────────────────
  private setupInteractions() {
    this.container.addEventListener('mousemove', () => this.showControls());
    this.container.addEventListener('mouseleave', () => {
      this.startHideTimer();
      // Close settings on mouse leave
      if (this.settingsMenu?.style.opacity === '1') this.toggleSettings();
    });
    this.video.addEventListener('click', () => this.togglePlay());
    this.video.addEventListener('dblclick', () => this.toggleFullscreen());

    // Seek
    this.seekBar!.addEventListener('input', () => {
      this.isSeeking = true;
      const val = Number(this.seekBar!.value);
      const time = (val / 1000) * this.video.duration;
      this.updateSeekVisual(val / 1000);
      this.timeDisplay!.textContent = `${formatTime(time)} / ${formatTime(this.video.duration)}`;
    });
    this.seekBar!.addEventListener('change', () => {
      const val = Number(this.seekBar!.value);
      this.video.currentTime = (val / 1000) * this.video.duration;
      store.dispatch(setCurrentTime(this.video.currentTime));
      this.isSeeking = false;
    });

    // Volume
    this.volumeSlider!.addEventListener('input', () => {
      const vol = Number(this.volumeSlider!.value) / 100;
      this.video.volume = vol;
      this.video.muted = vol === 0;
      this.volumeBtn!.innerHTML = vol === 0 ? ICONS.volumeMute : ICONS.volumeHigh;
    });
  }

  private setupVideoSync() {
    this.video.addEventListener('timeupdate', () => {
      if (this.isSeeking) return;
      const progress = this.video.currentTime / this.video.duration;
      this.seekBar!.value = String(Math.floor(progress * 1000));
      this.updateSeekVisual(progress);
      this.timeDisplay!.textContent = `${formatTime(this.video.currentTime)} / ${formatTime(this.video.duration)}`;
    });

    document.addEventListener('fullscreenchange', () => {
      const isFs = !!document.fullscreenElement;
      this.fullscreenBtn!.innerHTML = isFs ? ICONS.exitFullscreen : ICONS.fullscreen;
      this.showControls();
    });

    // Pause → show controls permanently + overlay flash
    this.video.addEventListener('pause', () => {
      this.playBtn!.innerHTML = ICONS.play;
      this.flashOverlay(true);
      this.showControls();
      if (this.hideTimeout) clearTimeout(this.hideTimeout);
    });

    // Play → start hide timer + overlay flash
    this.video.addEventListener('play', () => {
      this.playBtn!.innerHTML = ICONS.pause;
      this.flashOverlay(false);
      this.startHideTimer();
    });
  }

  private setupQualityLevels() {
    this.hlsManager.onQualityLevels((levels) => {
      this.qualityLevels = levels;
      this.populateQualityMenu();
      console.log(`[StreamForge] ${levels.length} quality levels detected:`, levels.map(l => l.label).join(', '));
    });
  }

  private updateSeekVisual(progress: number) {
    const fill = this.seekTrack?.querySelector('.sf-seek-fill') as HTMLElement | null;
    if (fill) fill.style.width = `${progress * 100}%`;
  }

  // ─── Actions ──────────────────────────────────────────────
  private togglePlay() {
    if (this.video.paused) this.video.play();
    else this.video.pause();
  }

  private toggleMute() {
    this.video.muted = !this.video.muted;
    this.volumeBtn!.innerHTML = this.video.muted ? ICONS.volumeMute : ICONS.volumeHigh;
    this.volumeSlider!.value = this.video.muted ? '0' : String(this.video.volume * 100);
  }

  private toggleFullscreen() {
    if (!document.fullscreenElement) {
      this.container.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  }

  private toggleSettings() {
    if (!this.settingsMenu) return;
    const isOpen = this.settingsMenu.style.opacity === '1';
    if (isOpen) {
      this.settingsMenu.style.opacity = '0';
      this.settingsMenu.style.transform = 'translateY(8px) scale(0.95)';
      this.settingsMenu.style.pointerEvents = 'none';
      setTimeout(() => { if (this.settingsMenu?.style.opacity === '0') this.renderSettingsPage('main'); }, 200);
    } else {
      this.settingsMenu.style.opacity = '1';
      this.settingsMenu.style.transform = 'translateY(0) scale(1)';
      this.settingsMenu.style.pointerEvents = 'auto';
    }
  }

  // ─── Controls Visibility ──────────────────────────────────
  private showControls() {
    this.controlsVisible = true;
    this.container.style.cursor = 'default';
    if (this.controlsEl) {
      this.controlsEl.style.opacity = '1';
      this.controlsEl.style.transform = 'translateY(0)';
    }
    this.startHideTimer();
  }

  private startHideTimer() {
    if (this.hideTimeout) clearTimeout(this.hideTimeout);
    this.hideTimeout = window.setTimeout(() => {
      if (!this.video.paused) {
        this.controlsVisible = false;
        this.container.style.cursor = 'none';
        if (this.controlsEl) {
          this.controlsEl.style.opacity = '0';
          this.controlsEl.style.transform = 'translateY(10px)';
        }
        // Close settings if open
        if (this.settingsMenu?.style.opacity === '1') this.toggleSettings();
      }
    }, 3000);
  }

  // ─── Store Subscription (chapters + heatmap) ──────────────
  private setupStoreSubscription() {
    let lastChapters: any[] = [];
    let lastHeatmap: any[] = [];

    store.subscribe(() => {
      const state = store.getState().player;

      if (state.chapters !== lastChapters) {
        lastChapters = state.chapters;
        this.updateChapters(state.chapters, state.duration);
      }

      if (state.heatmap !== lastHeatmap) {
        lastHeatmap = state.heatmap;
        this.updateHeatmap(state.heatmap);
      }
    });
  }

  private updateChapters(chapters: any[], duration: number) {
    if (!this.controlsEl || duration === 0) return;
    this.controlsEl.querySelectorAll('.sf-chapter').forEach(el => el.remove());

    chapters.forEach(chapter => {
      const pos = (chapter.start / duration) * 100;
      const marker = document.createElement('div');
      marker.className = 'sf-chapter';
      Object.assign(marker.style, {
        position: 'absolute', left: `${pos}%`,
        top: '0', bottom: '0', width: '2px',
        background: 'rgba(255,255,255,0.4)',
        zIndex: '105', pointerEvents: 'none',
      });
      this.controlsEl!.appendChild(marker);
    });
  }

  private updateHeatmap(heatmap: any[]) {
    if (!this.controlsEl) return;

    let overlay = this.controlsEl.querySelector('.sf-heatmap') as HTMLElement | null;
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'sf-heatmap';
      Object.assign(overlay.style, {
        position: 'absolute', top: '-18px', left: '16px', right: '16px',
        height: '18px', display: 'flex', alignItems: 'flex-end',
        pointerEvents: 'none', gap: '1px',
      });
      this.controlsEl.appendChild(overlay);
    }

    overlay.innerHTML = '';
    heatmap.forEach(point => {
      const bar = document.createElement('div');
      Object.assign(bar.style, {
        flex: '1',
        height: `${point.intensity * 100}%`,
        background: 'rgba(99, 102, 241, 0.5)',
        borderTopLeftRadius: '2px', borderTopRightRadius: '2px',
        transition: 'height 0.4s ease',
      });
      overlay!.appendChild(bar);
    });
  }
}
